import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ufaService {

  headers = new HttpHeaders();

  constructor(private _http: HttpClient) {}

        firmaInfo(data:any){
          return this._http.post(AppConfig.ipAddress + 'firmaInfo', data, {headers: this.headers})
          .pipe(map((res: any) => res ));
        }

        poslovnicaPopis(data:any){
          return this._http.post(AppConfig.ipAddress + 'poslovnicaPopis', data, {headers: this.headers})
          .pipe(map((res: any) => res ));
        }

        /** PARTNERI */
        dohvatiPartnere(data:any){
          return this._http.post(AppConfig.ipAddress + 'partner_popisV2', data, {headers: this.headers})
          .pipe(map((res: any) => res ));
        }

        primkastavkePopis(data:any){
          return this._http.post(AppConfig.ipAddress + 'primka_stavke_popis', data, {headers: this.headers})    
          .pipe(map((res: any) => res ));
        }

  /*** ULAZNA FAKTURA  */

        ufa(data:any){
          return this._http.post(AppConfig.ipAddress + 'ufa', data, {headers: this.headers})    
          .pipe(map((res: any) => res ));
        }
  
        ufaPopis(data:any){
          return this._http.post(AppConfig.ipAddress + 'ufa_Popis', data, {headers: this.headers})    
          .pipe(map((res: any) => res ));
        }

        otvorenaprimkaPopis(data:any){
          return this._http.post(AppConfig.ipAddress + 'otvorena_primka_popis', data, {headers: this.headers})
          .pipe(map((res: any) => res ));
        }

        dohvatibroj_ufe(data:any){
          return this._http.post(AppConfig.ipAddress + 'dohvatibroj_ufe', data, {headers: this.headers})
          .pipe(map((res: any) => res ));
        }

        ufaDodaj(data:any){
          return this._http.post(AppConfig.ipAddress + 'dodaj_ufu', data, {headers: this.headers})
            .pipe(map((res: any) => res ));
        }

        ufaUredi(data:any){
          return this._http.post(AppConfig.ipAddress + 'uredi_ufu', data, {headers: this.headers})
            .pipe(map((res: any) => res ));
        }

  zavrsenaufaUredi(data:any){
    return this._http.post(AppConfig.ipAddress + 'zavrsenaufaUredi', data, {headers: this.headers})
      .pipe(map((res: any) => res ));
  }

        dodajOtvorenuPrimku(data:any){
          return this._http.post(AppConfig.ipAddress + 'dodaj_otvorenu_primku', data, {headers: this.headers})
            .pipe(map((res: any) => res ));
        }

  nedovrsenaufaPrimkePopis(data:any){
    return this._http.post(AppConfig.ipAddress + 'nedovrsenaufaPrimkePopis', data, {headers: this.headers})    
    .pipe(map((res: any) => res ));
  }

        ufastavkaPopis(data:any){
          return this._http.post(AppConfig.ipAddress + 'ufa_stavka_popis', data, {headers: this.headers})    
          .pipe(map((res: any) => res ));
        }

        ufaifaPovezaniDokumenti(data:any){
          return this._http.post(AppConfig.ipAddress + 'ufaifa_povezani_dokumenti', data, {headers: this.headers})    
          .pipe(map((res: any) => res ));
        }

  ufaPrimkePopis(data:any){
    return this._http.post(AppConfig.ipAddress + 'ufaPrimkePopis', data, {headers: this.headers})    
    .pipe(map((res: any) => res ));
  }

  otvorenaprimkaObrisi(data:any){
    return this._http.post(AppConfig.ipAddress + 'otvorenaprimkaObrisi', data, {headers: this.headers})
      .pipe(map((res: any) => res ));
  }

  uredi_ufu_primku_prije_zakljucivanja(data:any){
    return this._http.post(AppConfig.ipAddress + 'uredi_ufu_primku_prije_zakljucivanja', data, {headers: this.headers})
      .pipe(map((res: any) => res ));
  }

  /** ZAVISNI TROŠAK U PRIMCI  */
  nedovrsenaufa_zavisnitrosakPopis(data:any){
    return this._http.post(AppConfig.ipAddress + 'nedovrsenaufa_zavisnitrosakPopis', data, {headers: this.headers})    
    .pipe(map((res: any) => res ));
  }

  
  
  ufa_zavisnitrosakDodaj(data:any){
    return this._http.post(AppConfig.ipAddress + 'ufa_zavisnitrosakDodaj', data, {headers: this.headers})
      .pipe(map((res: any) => res ));
  }

  ufa_zavisnitrosakUredi(data:any){
    return this._http.post(AppConfig.ipAddress + 'ufa_zavisnitrosakUredi', data, {headers: this.headers})
      .pipe(map((res: any) => res ));
  }

  ufa_zavisnitrosakObrisi(data:any){
    return this._http.post(AppConfig.ipAddress + 'ufa_zavisnitrosakObrisi', data, {headers: this.headers})
      .pipe(map((res: any) => res ));
  }

  ufa_zavisnitrosakPopis(data:any){
    return this._http.post(AppConfig.ipAddress + 'ufa_zavisnitrosakPopis', data, {headers: this.headers})    
    .pipe(map((res: any) => res ));
  }



        zavrsi_ufu(data:any){
          return this._http.post(AppConfig.ipAddress + 'zavrsi_ufu', data, {headers: this.headers})
            .pipe(map((res: any) => res ));
        }

  storno_kalkulacija(data:any){
    return this._http.post(AppConfig.ipAddress + 'ufa_storno', data, {headers: this.headers})
      .pipe(map((res: any) => res ));
  }


        ufaObrisi(data:any){
          return this._http.post(AppConfig.ipAddress + 'obrisi_ufu', data, {headers: this.headers})
            .pipe(map((res: any) => res ));
        }

  primka_stavka_uredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'primka_stavka_uredi', a)
      .pipe(map((res: any) => res));
  }

  /*** ZAVISNI TROŠKOVI  */
  zavisnitrosak(data:any){
    return this._http.post(AppConfig.ipAddress + 'zavisnitrosak', data, {headers: this.headers})    
    .pipe(map((res: any) => res ));
  }

  zavisnitrosakPopis(data:any){
    return this._http.post(AppConfig.ipAddress + 'zavisnitrosakPopis', data, {headers: this.headers})    
    .pipe(map((res: any) => res ));
  }
}
